import React from "react";
import { Container, Row, Col } from "reactstrap";
import ValidateLightNumber from "./ValidateLightNumber";
import appConfig from "../data/appConfig";
import langUI from "../data/langUI";
// image displayed in the form header section
import formImage from "../assets/gmd.jpg";
import ModalAppIntro from "./ModalAppIntro";

// ******* set up TERMs used in the form and/or this app
// *** global scope
const appHelp = combineTerms(langUI["help"], "tc", "en");

// *** app scope
const lightType = ["Light Type", "點燈類別"];
const lightTypeBL = combineTerms(lightType);
const lightTypeLabel = {
  0.5: "半年 half year $60",
  1: "一年 1 year $120",
  3: "三年 3 years $360",
};

const startDate = "起日 Start Date";
const expireDate = "迄日 Expire Date";

const regType = ["Registration Type", "登記類別"];
const regTypeBL = combineTerms(regType);
const regTypeValue = { 1: "新燈 New Light", 0: "續燈 Existing Light" };

const benef = ["Beneficiary", "點燈受益人"];
const benefBL = combineTerms(benef);
const donor = ["Donor", "點燈人"];
const donorBL = combineTerms(donor);
const contact = ["Contact", "連絡人"];
const contactBL = combineTerms(contact);
const contactArr = ["姓名 Name", "電話 Phone", "電郵 Email"];

//const lightID = ["Light Number", "燈號"];

const lightIDExist = ["Existing Light Number", "舊燈燈號"];
const lightIDExistBL = combineTerms(lightIDExist);
const remarks = ["Remarks", "備註"];
const remarksBL = combineTerms(remarks);

const donorIsContact = "點燈人即連絡人 Donor is Contact";
const previewInput = "預覽資料 Preview Inputs"; // submit button label
const previewTitle = "已登記資料 Registered Info"; // preview title
const totalToDonate = "待捐款金額 Amount to donate at Paypal";
const prevColumnWarning = "請先填前面一欄 (column)";
//const memInfoArr = ['信眾編號 Member ID', '姓名 Name', '地址 Address', '城市 City'];

const destURL = appConfig["appSet"]["link"] + "/gmd-form2.php";
const lightPrice = 120; // light price per year
const maxNameNo = 4; // max number of (beneficiary) names on a light
const maxDonorField = 10; // total Donor data fields
const maxContactField = 3; // total Contact data fields
const maxComments = 250; // max comments length acceptable; 250

// combine bilingual terms into one; DC: 3/12/2021
// this one has to be defined as function or appHelp before this will not work
// define it as function hoist it to the top, make it possible to use appHelp before this function
function combineTerms(inTerm, front = 1, back = 0) {
  // default to 1, 0 if not passed;
  // i.e., Chinese first, then English
  return inTerm[front] + " " + inTerm[back];
}

let isDate = function (input) {
  if (Object.prototype.toString.call(input) === "[object Date]") return true;
  return false;
};

function getCustDate(inDate, dateFormat) {
  // get customized date format
  if (!isDate(inDate)) {
    return "Wrong Date type";
  }
  let dd = String(inDate.getDate());
  let mm = String(inDate.getMonth() + 1);
  let yyyy = inDate.getFullYear();
  let options = { month: "numeric", day: "numeric", year: "numeric" };
  switch (dateFormat) {
    case "mm/dd/yyyy":
      return mm + "/" + dd + "/" + yyyy;
    //break;
    case "yyyy-mm-dd":
      return yyyy + "-" + mm + "-" + dd;
    //break;
    default:
      return inDate.toLocaleString("en-US", options);
  }
}

function getEndDate(bDate, years) {
  /*  Pass bDate (Begin Date) with Date object
		years (tempForm.get('light_year')) is passed as STRING
		if it's in integral year, just add number of year to the Begin Date.
		calculate with number of days only if the year passed is not integer
	*/
  if (!isDate(bDate)) {
    return "Wrong Date Type";
  }

  //let dd = String(bDate.getDate()).padStart(2, '0');
  //let mm = String(bDate.getMonth() + 1).padStart(2, '0'); //January is 0!
  let dd = String(bDate.getDate());
  let mm = String(bDate.getMonth() + 1);
  let yyyy = bDate.getFullYear();

  if (Number(years) === parseInt(years)) {
    // what passed is an integer
    // 1 or 3 in this app as of 3/18/2021
    let endYear = parseInt(years) + yyyy;
    return mm + "/" + dd + "/" + endYear;
  }

  const daysInAYear = 365.25;
  let duration = parseFloat(years) * daysInAYear;
  let endMinSec = new Date(bDate.getTime() + duration * 24 * 60 * 60 * 1000);
  return getCustDate(endMinSec, "mm/dd/yyyy");
}

/*
const validateEmail = email => { // will return true or false
	var re = /\S+@\S+\.\S+/;
	return re.test(email);
}

const getCheckedRadioValue = input_name => {
	var ele = document.getElementsByName(input_name);
	for(let i = 0; i < ele.length; i++) {
		if(ele[i].checked) return ele[i].value;
	}                                      
}

const jsXOR = (a,b) => { // JavaScript XOR
	return ( a || b ) && !( a && b );
}
*/

class InputForm extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {submitNow: '0'};   // to check if it's time to submit
    this.state = { dcValue: "0" }; // is donor the same as contact?
    this.state = { regType: "1" }; // new light or renew existing light
    this.state = { lightYear: "1" }; // Light duration
    this.state = { showSummary: false, inputSummary: "123" };
    this.state = { appChecked: false };
    this.state = { lightID: "" };
    this.state = { lightIDValid: 0 }; // if theLight ID is validated
    this.state = { preview: true }; // enable the Preview button
    this.state = { expDate: "" }; // expire date

    this.state = {
      // show or hide specific div in Validating Light Number area
      vlnS0: "pt-2 show-it",
      vlnS1e: "pt-2 hide-it",
      vlnS1s: "pt-2 hide-it",
      vlnS2c: "pt-2 hide-it",
      vlnS2n: "pt-2 hide-it",
    };

    this.appForm = React.createRef();
    //this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // without this function, the following states will become undefined
    // to prevent contact being hidden after first load
    this.setState({ dcValue: "0" });
    this.setState({ regType: "1" });
    this.setState({ lightYear: "1" }); // Light duration
    this.setState({ appChecked: false });
    this.setState({ preview: true }); // Preview button on / off
  }

  onLightStatus = (lID, lValid = 0, setPreview = true, expDate = "") => {
    // rise lightStatus from child to parent
    this.setState({ lightID: lID }); // Light ID
    this.setState({ lightIDValid: lValid }); // Light ID being validated
    this.setState({ preview: setPreview }); // Preview button on / off
    this.setState({ expDate: expDate }); // expire date
  };

  handleContact = (event) => {
    // show or hide Contact fields
    // cannot just assign dcValue to target value, kind of like dog chasing its tail 3/10/2021
    if (event.target.value === "1") {
      this.setState({ dcValue: "0" });
    } else {
      this.setState({ dcValue: "1" });
    }
  };

  handleLS = (event) => {
    // decide to display new (1) or renew (0) light block
    this.setState({ regType: event.target.value });
    if (this.state.dcValue === "1") {
      this.setState({ dcValue: "1" });
      this.setState({ appChecked: true });
    } else {
      this.setState({ dcValue: "0" });
      this.setState({ appChecked: false });
    }
    this.setState({ preview: true }); // Preview button on/off
    this.setState({ lightID: "" }); // reset Light ID
    this.setState({ lightIDValid: 0 }); // Light ID Validated?
  };

  handleLIDChange = (e) => {
    this.setState({ lightID: e.target.value });
  };

  handleModify = () => {
    this.setState({ showSummary: false });
  };

  handleSubmit = (e) => {
    // submit the form
    /* since light_no input field was disabled after the ID was confirmed
		that field is then not available in form submit process
		so it has to be re-created and inserted, value assigned to it */

    if (this.state.lightIDValid) {
      // if Light ID has been validated
      // set up the parent node
      var x = document.getElementById("app_form");
      // create an input field to insert
      var new_field = document.createElement("input");
      new_field.setAttribute("type", "text");
      new_field.setAttribute("name", "light_no");
      new_field.setAttribute("id", "light_no");
      new_field.setAttribute("value", this.state.lightID);
      // select last position to insert element before it
      var pos = x.childElementCount;
      // insert it as a child node
      x.insertBefore(new_field, x.childNodes[pos]);
    }
    document.getElementById("app_form").submit();
    return;
  };

  ValidateForm = (e) => {
    e.preventDefault(); // prevent form from submitting
    const tempForm = new FormData(e.target); // assign all form data to this object
    //console.log(tempForm); // this one give you the whole Form object

    // ******* pass all form fields to an array
    const frmElements = [];
    for (let [key, value] of tempForm.entries()) {
      frmElements[key] = value;
    } // contact[i][j] is the key, so to get its value, go by tempForm.get('contact[1][0]')

    // ******* validate form inputs
    // ***** validate the common inputs for both New and Renew registrations first
    // *** check comments length
    if (tempForm.get("comments").length > maxComments) {
      alert(
        remarks[1] +
          "欄請勿超過 " +
          maxComments +
          " 字. Please limit your " +
          remarks[0] +
          " to less than " +
          maxComments +
          " characters"
      );
      return;
    }

    // ***** validate the inputs on renew and new type
    //let passedLightID = '';
    if (tempForm.get("reg_type") !== "1") {
      // ***** validate Renew light
      if (this.state.lightIDValid !== 1) {
        if (!tempForm.get("light_no")) {
          alert(lightIDExist[1] + "必須填 " + lightIDExist[0] + " is required");
          return;
        }
      }

      if (this.state.lightIDValid === 0) {
        alert("Press 確認燈號 to validate Light Number"); //this.state.lightID + " is not validated"
        return;
      }
    } else {
      // ***** validate New light
      // make sure the first beneficiary name is filled in the 1st column, and nothing blank in between
      for (let i = 0; i < maxNameNo; i++) {
        if (
          !tempForm.get("benefName[" + i + "]") &&
          tempForm.get("benefName[" + (i + 1) + "]")
        ) {
          alert(prevColumnWarning + ": " + benef[1] + " " + (i + 1));
          return;
        }
      }

      // ***** after making sure 1st column is the 1st to enter from the process above
      // check only the 1st column is required
      if (!tempForm.get("benefName[0]")) {
        alert(
          "至少填一" + benef[1] + "名 Fill at least one " + benef[0] + " name."
        );
        return;
      }

      // ***** check the donor's required fields
      if (!tempForm.get("contact[0][0]") && !tempForm.get("contact[0][1]")) {
        alert(donorBL + ": 至少填一名字 Fill at least one name.");
        return;
      }
      if (!tempForm.get("contact[0][2]") && !tempForm.get("contact[0][3]")) {
        alert(donorBL + ": 至少填一電話號碼 Fill at least one phone number.");
        return;
      }

      const reqField = [4, 6, 7, 8, 9];
      for (let i = 0; i < reqField.length; i++) {
        if (!tempForm.get("contact[0][" + reqField[i] + "]")) {
          alert(
            appConfig["donorInfo"][reqField[i]][0] +
              "不能空白 " +
              appConfig["donorInfo"][reqField[i]][1] +
              " is required."
          );
          return;
        }
      }

      // *** if the donor is not the contact, make sure contact info is filled
      if (!tempForm.get("donor_contact")) {
        if (
          !tempForm.get("contact[1][0]") ||
          !tempForm.get("contact[1][1]") ||
          !tempForm.get("contact[1][2]")
        ) {
          alert(
            "若" +
              contact[1] +
              "與" +
              donor[1] +
              "非同一人, " +
              contact[1] +
              "姓名, 電郵, 電話 為必填欄 " +
              contact[0] +
              " Name, Email, and Phone are required."
          );
          return;
        }
      }
    }

    // ******* start to build Input Summary
    let inputSummary = '<h3 class="pt-3">' + previewTitle + "</h3>";
    inputSummary +=
      "<p>" +
      lightTypeBL +
      ": " +
      lightTypeLabel[tempForm.get("light_year")] +
      "</p>";
    inputSummary +=
      "<p>" +
      regTypeBL +
      ": " +
      regTypeValue[tempForm.get("reg_type")] +
      "</p>";

    // start / expire dates
    let startDateLight = "";
    let expDateLight = "";
    var today = new Date(); // basic time reference - UTC value

    if (tempForm.get("reg_type") !== "1") {
      // renew
      // Date format retrieved from MySQL: 2021-04-05 10:06:30"
      // This is the New York local time. Need to convert it to UTC.
      // Split timestamp into [ Y, M, D, h, m, s ]
      // var t = "2010-06-09 13:12:01".split(/[- :]/);
      var t = this.state.expDate.split(/[- :]/);
      // since the time recorded is for New York, add 8 hours to offset
      var tempExpDate = new Date(
        Date.UTC(t[0], t[1] - 1, t[2], t[3] + 8, t[4], t[5])
      );
      var diff = today.getTime() - tempExpDate.getTime();
      var diffDays = Math.floor(diff / 1000 / 60 / 60 / 24);
      if (diffDays > 31) {
        // 92 -> 31 on 1/9/2024
        // reset to 3 month = 1/4 year = 365/4 = 91 on 5/9/2021;
        // if expire date is more than 6 months = 365/2 old
        alert(
          "此燈號已過期超過 1 個月, 請重新登記 This Light expired more than 1 month ago. Please start with New"
        );
      } else {
        startDateLight = getCustDate(tempExpDate, "mm/dd/yyyy");
        expDateLight = getEndDate(tempExpDate, tempForm.get("light_year"));
      }
    } else {
      startDateLight = getCustDate(today, "mm/dd/yyyy");
      expDateLight = getEndDate(today, tempForm.get("light_year"));
    }
    inputSummary += "<p>" + startDate + ": " + startDateLight + "<br />";
    inputSummary += expireDate + ": " + expDateLight + "</p>";
    inputSummary += "<hr />";

    // ***** build summary on renew and new type
    let tempLID = "";
    if (tempForm.get("reg_type") !== "1") {
      // validate Renew light
      if (this.state.lightID !== "") {
        tempLID = this.state.lightID;
      } else {
        tempLID = tempForm.get("light_no");
      }
      inputSummary += "<p>" + lightIDExistBL + ": " + tempLID + "</p>";
      inputSummary += "<hr />";
    } else {
      // build xiaozai (beneficiary) section summary
      let xiaozaiSectSummary = "";
      //let xiaozaiNameNum = 0;
      for (let i = 0; i < maxNameNo; i++) {
        let tempKey = "benefName[" + i + "]";
        if (!tempForm.get(tempKey)) {
          // if the name is blank
          break;
        } else {
          //xiaozaiNameNum++; // actual xiaozai tablet number requested
          if (xiaozaiSectSummary.length === 0) {
            xiaozaiSectSummary += tempForm.get(tempKey);
          } else {
            xiaozaiSectSummary += "; " + tempForm.get(tempKey);
          }
        }
      }

      if (xiaozaiSectSummary.length > 0) {
        inputSummary += '<div class="app-bold">' + benefBL + "</div>";
        inputSummary += xiaozaiSectSummary + "<hr />";
      }

      // ***** build donor section summary
      let donorSectSummary = '<div class="app-bold">' + donorBL + "</div>";
      for (let i = 0; i < maxDonorField; i++) {
        if (tempForm.get("contact[0][" + i + "]")) {
          donorSectSummary +=
            appConfig["donorInfo"][i][0] +
            " " +
            appConfig["donorInfo"][i][1] +
            ": " +
            tempForm.get("contact[0][" + i + "]") +
            "<br />";
        }
      }
      inputSummary += donorSectSummary;

      // *** build contact section if the donor is not the contact
      if (tempForm.get("donor_contact") !== "1") {
        let contactSectSummary =
          '<div class="app-bold pt-3">' + contactBL + "</div>";
        for (let i = 0; i < maxContactField; i++) {
          if (tempForm.get("contact[1][" + i + "]")) {
            // if the field is not blank
            contactSectSummary +=
              contactArr[i] +
              ": " +
              tempForm.get("contact[1][" + i + "]") +
              "<br />";
          }
        }
        inputSummary += contactSectSummary;
      }
      inputSummary += "<hr />";
    }

    // ***** build comments
    if (tempForm.get("comments") && tempForm.get("comments").length > 0) {
      inputSummary +=
        remarksBL + ":<br />" + tempForm.get("comments") + "<hr />";
    }

    // ***** amount to donate
    let total = tempForm.get("light_year") * lightPrice;
    inputSummary +=
      totalToDonate + ': <span class="app-bold">$' + total + "</span>";

    this.setState({ showSummary: true });
    this.setState({ inputSummary: inputSummary });
    return;
  };

  render() {
    return (
      <Container fluid={false} className="input-form">
        <Row style={{ display: this.state.showSummary ? "block" : "none" }}>
          <Col>
            <div
              className="frm-summary"
              dangerouslySetInnerHTML={{ __html: this.state.inputSummary }}
            ></div>
            <div className="act-buttons">
              <button
                type="submit"
                name="btnSummary"
                style={{ width: "250px" }}
                onClick={this.handleSubmit}
              >
                寄出 SUBMIT
              </button>
              &nbsp;
              <button
                type="button"
                name="btnModify"
                style={{ width: "250px" }}
                onClick={this.handleModify}
              >
                修改 MODIFY INPUTS
              </button>
            </div>
          </Col>
        </Row>
        <Row
          style={{ display: this.state.showSummary ? "none" : "block" }}
          className="app-sect"
        >
          <Col className="text-center">
            <h3>{appConfig["formSet"]["title"]}</h3>
            <img
              style={{ maxWidth: "100%" }}
              src={formImage}
              alt="Longevity Light"
            />
            <ModalAppIntro modTitle={appHelp} />
          </Col>
        </Row>
        <form
          id="app_form"
          method="post"
          action={destURL}
          onSubmit={this.ValidateForm}
          style={{ display: this.state.showSummary ? "none" : "block" }}
        >
          <Row>
            <Col className="section-criteria">
              <div className="app-sect-title text-center highlight-color">
                {lightTypeBL}
              </div>
              <Row>
                <Col xs="12" sm="4" className="right-col">
                  <input type="radio" name="light_year" value="3" />
                  <label>&nbsp;{lightTypeLabel["3"]}</label>
                </Col>
                <Col xs="12" sm="4" className="text-center">
                  <input
                    type="radio"
                    name="light_year"
                    value="1"
                    defaultChecked
                  />
                  <label>&nbsp;{lightTypeLabel["1"]}</label>
                </Col>
                <Col xs="12" sm="4" className="left-col">
                  <input type="radio" name="light_year" value="0.5" />
                  <label>&nbsp;{lightTypeLabel["0.5"]}</label>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6" className="right-col">
                  <input
                    type="radio"
                    name="reg_type"
                    value="1"
                    onClick={this.handleLS}
                    defaultChecked
                  />
                  <label style={{ fontWeight: 700 }}>&nbsp;{"新 New"}</label>
                </Col>
                <Col xs="12" sm="6" className="left-col">
                  <input
                    type="radio"
                    name="reg_type"
                    value="0"
                    onClick={this.handleLS}
                  />
                  <label style={{ fontWeight: 700 }}>&nbsp;{"續 Renew"}</label>
                </Col>
              </Row>
            </Col>
          </Row>

          {this.state.regType === "0" ? (
            <ValidateLightNumber lightStatus={this.onLightStatus} />
          ) : (
            <Row>
              <Col className="app-sect section-new text-center">
                <div className="app-sect-title highlight-color">
                  新燈 New Light
                </div>
                <p>
                  <span className="app-sect-subtitle highlight-color">
                    {benef[1]}（燈上名字）{benef[0]} Name(s)
                  </span>
                  <br />
                  每盞燈至少一個, 最多可寫四個姓名 Min 1 name, up to 4 names per
                  Light
                </p>
                <Row>
                  <Col xs="12" md="3">
                    1.{" "}
                    <input
                      type="text"
                      name="benefName[0]"
                      size="15"
                      maxLength="6"
                      placeholder="姓名 Full Name"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    2.{" "}
                    <input
                      type="text"
                      name="benefName[1]"
                      size="15"
                      maxLength="6"
                      placeholder="姓名 Full Name"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    3.{" "}
                    <input
                      type="text"
                      name="benefName[2]"
                      size="15"
                      maxLength="6"
                      placeholder="姓名 Full Name"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    4.{" "}
                    <input
                      type="text"
                      name="benefName[3]"
                      size="15"
                      maxLength="6"
                      placeholder="姓名 Full Name"
                    />
                  </Col>
                </Row>
                <h5 className="highlight-color pt-3">{donorBL}</h5>
                <p>
                  若不清楚那些為必填, 請點閱上面的"說明"連結
                  <br />
                  If not sure what fields are required, check out the "Help"
                  link above.
                </p>
                <Row className="contact-wrapper">
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][0]">中名&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][0]"
                      placeholder="Chinese Name"
                      size="15"
                      maxLength="6"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][1]">英名&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][1]"
                      placeholder="English Name"
                      size="15"
                      maxLength="20"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][2]">手機&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][2]"
                      pattern="^[0-9()-1{e}1{x}1{t}]*$"
                      title="Must contain only numbers 0 - 9, (, ), -, e, x, and t"
                      placeholder="Cell Phone"
                      size="15"
                      maxLength="15"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][3]">座機&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][3]"
                      pattern="^[0-9()-1{e}1{x}1{t}]*$"
                      title="Must contain only numbers 0 - 9, (, ), -, e, x, and t"
                      placeholder="Home Phone"
                      size="15"
                      maxLength="15"
                    />
                  </Col>
                </Row>
                <Row className="contact-wrapper">
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][4]">電郵&nbsp;</label>
                    <input
                      type="email"
                      name="contact[0][4]"
                      placeholder="Email"
                      size="15"
                      maxLength="30"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][5]">性別&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][5]"
                      title=""
                      placeholder="Sex"
                      size="15"
                      maxLength="6"
                    />
                  </Col>
                </Row>
                <Row className="contact-wrapper">
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][6]">地址&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][6]"
                      placeholder="Address"
                      size="15"
                      maxLength="40"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][7]">城市&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][7]"
                      placeholder="City"
                      size="15"
                      maxLength="20"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][8]">州別&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][8]"
                      title=""
                      placeholder="State"
                      size="15"
                      maxLength="20"
                    />
                  </Col>
                  <Col xs="12" md="3">
                    <label htmlFor="contact[0][9]">區碼&nbsp;</label>
                    <input
                      type="text"
                      name="contact[0][9]"
                      title=""
                      placeholder="Zip Code"
                      size="15"
                      maxLength="10"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" className="same-as-donor highlight-color">
                    <input
                      type="checkbox"
                      name="donor_contact"
                      onChange={this.handleContact}
                      style={{ width: "20px" }}
                      value={this.state.dcValue}
                      defaultChecked={this.state.appChecked}
                    />
                    <label htmlFor="donor_contact">
                      &nbsp;{donorIsContact}
                    </label>
                  </Col>
                </Row>
                {this.state.dcValue === "0" ? (
                  <div>
                    <p className="app-sect-subtitle highlight-color">
                      {contactBL}
                    </p>
                    <Row className="contact-wrapper">
                      <Col xs="12" md="4">
                        <label htmlFor="contact[1][0]">姓名&nbsp;</label>
                        <input
                          type="text"
                          name="contact[1][0]"
                          placeholder="Full Name"
                          size="15"
                          maxLength="6"
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label htmlFor="contact[1][1]">電郵&nbsp;</label>
                        <input
                          type="email"
                          name="contact[1][2]"
                          placeholder="Email"
                          size="15"
                          maxLength="30"
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <label htmlFor="contact[1][2]">電話&nbsp;</label>
                        <input
                          type="text"
                          name="contact[1][1]"
                          pattern="^[0-9()-1{e}1{x}1{t}]*$"
                          title="Must contain only numbers 0 - 9, (, ), -, e, x, and t"
                          placeholder="Phone"
                          size="15"
                          maxLength="15"
                        />
                      </Col>
                    </Row>
                  </div>
                ) : (
                  <div></div>
                )}
              </Col>
            </Row>
          )}
          <Row>
            <Col className="misc-section">
              <Row>
                <Col xs="12">
                  <div className="form-remarks">
                    <p>
                      備註 Remarks: 名字若太長, 請將全名寫在備註欄,
                      或其他跟點燈有關事項.
                      <br />
                      If the name is too long, write the complete name in the
                      Remark box or any other light related matters.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6">
                  <div>
                    <textarea
                      name="comments"
                      rows="4"
                      maxLength="245"
                    ></textarea>
                  </div>
                </Col>
                <Col xs="12" sm="6" className="btn-submit">
                  <button
                    type="submit"
                    name="btnValidate"
                    style={{ width: "250px" }}
                    disabled={this.state.preview ? "" : "disabled"}
                  >
                    {previewInput}
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      </Container>
    );
  }
}

export default InputForm;
